<template>
<div class="openClass app-content">
  <div class="head-box">
    <span>当前位置： </span>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item><a href="/">公开课</a></el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="openClass-body">
    <div class="titleI">全部课程</div>
    <cur-list v-if="currList.length > 0" :curriculumData="currList" openType="open"></cur-list>
    <pagination :total="currData.totalCount" :pageSize=8 :currentChange="currentChange"></pagination>
  </div>
</div>
</template>

<script>
import curList from '../components/curList'
import pagination from '../components/pagination'
// const curriculumData = require('../../mock/curriculumData.json')
export default {
  name: 'openClass',
  components: {
    curList,
    pagination
  },
  data () {
    return {
      currList: [],
      currData: ''
    }
  },
  mounted () {
    this.getOpenClass()
  },
  methods: {
    getOpenClass (page) {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olopenclass/list',
        params: {
          'page': page,
          'limit': 8
        }
      }).then((result) => {
        console.log(result)
        if (result.data.code === 0) {
          that.currList = result.data.page.list
          that.currData = result.data.page
        }
      })
    },
    currentChange (val) {
      this.getOpenClass(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.openClass{
  width: 1200px;
  margin: 0px auto;
  .openClass-body{
    .titleI{
      font-size: 24px;
      font-weight: bold;
      color: #666;
      padding: 20px 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/openClass.vue